import { genId } from './ids.js';
/** Is a message currently expired (should be cleared) at `nowMs`? */
export function isExpired(message, nowMs) {
    return message.expiresAt !== undefined && nowMs >= message.expiresAt;
}
/** Return the visible message, or null when it has expired. */
export function visibleMessage(message, nowMs) {
    if (message === null)
        return null;
    return isExpired(message, nowMs) ? null : message;
}
/** Build a fully-formed InfoMessage with sensible defaults and an id/timestamp. */
export function makeMessage(input, nowMs = Date.now()) {
    return {
        id: genId('msg'),
        type: input.type,
        heading: input.heading ?? defaultHeading(input.type),
        body: input.body,
        priority: input.priority ?? (input.type === 'urgent' ? 3 : 1),
        createdAt: nowMs,
        expiresAt: input.ttlMs !== undefined ? nowMs + input.ttlMs : undefined,
        colour: input.colour,
        vibrate: input.vibrate,
        requireAck: input.requireAck,
    };
}
function defaultHeading(type) {
    switch (type) {
        case 'question':
            return 'ASK';
        case 'fact':
            return 'FACT';
        case 'cue':
            return 'CUE';
        case 'timer':
            return 'TIME';
        case 'urgent':
            return 'URGENT';
        case 'ai':
            return 'AI';
        case 'message':
        default:
            return 'NOTE';
    }
}
// Ordered to fill a 3-column grid, row by row (see producer .cue-pad).
export const QUICK_CUES = [
    // Row 1
    { key: 'nextq', label: 'Next question', type: 'question', heading: 'ASK', body: '' },
    { key: 'fact', label: 'Hot fact', type: 'fact', heading: 'FACT', body: '' },
    { key: 'video', label: 'Video next', type: 'cue', heading: 'NEXT', body: '' },
    // Row 2
    { key: 'cam1', label: 'Main Camera', type: 'cue', heading: 'CUE', body: 'Main Camera', ttlMs: 8000 },
    { key: 'cam2', label: 'Camera 2', type: 'cue', heading: 'CUE', body: 'Camera 2', ttlMs: 8000 },
    { key: 'smile', label: 'Smile', type: 'cue', heading: 'CUE', body: 'Smile', ttlMs: 6000, colour: 'blue' },
    // Row 3
    { key: 'slow', label: 'Slow down', type: 'cue', heading: 'CUE', body: 'Slow down', ttlMs: 6000 },
    { key: 'pause', label: 'Pause', type: 'cue', heading: 'CUE', body: 'Pause', ttlMs: 6000 },
    { key: 'faster', label: 'Speed up', type: 'cue', heading: 'CUE', body: 'Speed up', ttlMs: 6000 },
    // Row 4
    { key: '2min', label: 'Two Minutes', type: 'timer', heading: 'TIME', body: '2 minutes remaining', ttlMs: 10000 },
    { key: '30sec', label: '30 Seconds', type: 'timer', heading: 'TIME', body: '30 seconds', ttlMs: 10000 },
    { key: 'wrap', label: 'Wrap up!', type: 'urgent', heading: 'URGENT', body: 'Wrap up!', colour: 'red' },
];
//# sourceMappingURL=cues.js.map